import { ContentType } from '@creditsights/api-ui-web';
import { Article, ContentTypeTag } from '../../../models';
import { ArticleListItems } from '../../../models/ArticleListItems';
import { ArticleTableRow } from '../../../models/ArticleTableRow';
import { ArticleDto } from '../../../services/dtos/article/article.dto';
import { ArticleListDto } from '../../../services/dtos/article/articleList.dto';
import { ArticleListItemDto } from '../../../services/dtos/article/articleListItem.dto';
import { TagDto } from '../../../services/dtos/tags/tag.dto';
import { getCompanies } from '../../../utils/tagUtils';

export const ContentTypeTagMapping: Record<ContentTypeTag, ContentType> = {
  [ContentTypeTag.Research]: ContentType.Research,
  [ContentTypeTag.Covenants]: ContentType.Covenants,
  [ContentTypeTag.News]: ContentType.News,
};

export const mapArticleListItemDtoToArticleTableRow = (articleList: ArticleListItemDto[]): ArticleTableRow[] =>
  articleList.map((article) => ({
    ...article,
    articleType: getArticleTypeName(article.tags),
    companies: getCompanies(article.tags),
  }));

export const getArticleTypeName = (articleTag: TagDto[]): ContentType | undefined => {
  const contentTypeTag = articleTag.find((tag) =>
    [ContentTypeTag.Research, ContentTypeTag.News, ContentTypeTag.Covenants].some(
      (contentType) => contentType === tag.tagId
    )
  );
  return contentTypeTag ? ContentTypeTagMapping[contentTypeTag.tagId] : undefined;
};

export const mapToArticleListItems = (dto: ArticleListDto): ArticleListItems => {
  const rows = mapArticleListItemDtoToArticleTableRow(dto.results);
  return { rows, totalResults: dto.totalResults };
};

export const mapArticleDtoToArticle = (article: ArticleDto): Article => ({
  ...article,
  content: {
    ...article.content,
    includedContent: article.content.includedContent?.map((includedContent) => ({
      id: includedContent.id,
      modifiedDate: includedContent.modifiedDate,
      publishDate: includedContent.publishDate,
      content: includedContent.content,
      tags: includedContent.tags,
      articleType: getArticleTypeName(includedContent.tags),
      companies: getCompanies(includedContent.tags),
      canAccess: includedContent.canAccess,
    })),
  },
  articleType: getArticleTypeName(article.tags),
  companies: getCompanies(article.tags),
});
